import React from "react";
import { Role } from "../../schemas/roleSchema";
import Modal from "../common/Modal";

interface RoleDisplayProps {
  isOpen: boolean;
  onClose: () => void;
  data: Role;
}

const RoleDetails: React.FC<RoleDisplayProps> = ({ isOpen, onClose, data }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Role Details" size="xl">
      <div className="space-y-6">
        <div className="grid grid-cols-1 gap-4">
          <div>
            <p className="text-sm text-gray-500">Role Name</p>
            <p className="text-base font-medium text-gray-900">{data.name}</p>
          </div>
          {data.description && (
            <div>
              <p className="text-sm text-gray-500">Description</p>
              <p className="text-base font-medium text-gray-900">{data.description}</p>
            </div>
          )}
        </div>

        <div>
          <h3 className="text-md font-semibold mb-2 text-gray-800">
            Permissions ({data.permissions?.length || 0})
          </h3>
          {data.permissions && data.permissions.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {data.permissions.map((permission) => {
                const [module, action] = permission.action.split(".");
                return (
                  <div
                    key={permission.id}
                    className="p-3 border border-gray-200 rounded-lg bg-gray-50"
                  >
                    <div className="flex flex-col">
                      <div className="font-medium text-gray-900 capitalize">
                        {module}
                      </div>
                      <div className="text-sm text-gray-500 capitalize">
                        {action}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500 border border-gray-200 rounded-lg">
              No permissions assigned to this role.
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default RoleDetails;
